import React from 'react';
import * as RatingIcons from './RatingIcons';
import DataAPI from '../../../Utils/Api';
import { T, TString } from '../Response/Utils';
import styled from 'styled-components';

interface Props {
	number?: number | 3 | 5 | 10;
	filled?: number;
	onChange?: Function;
	foregroundColor?: string;
	backgroundColor?;
	description?: any;
	noLabel?: boolean;
	noOutlineHover?: boolean;
	name?: '';
	width?: string;
	disable?: boolean;
	iconSize?: string;
	gap?: number;
	isClickable?: boolean;
	purpose?: string;
	popUpSnackBar?: Function;
	voiceResponse?: boolean;
	isResponselevelFeedback?: boolean;
	channel?: string;
	openThumbsPopup?: Function;
	thumbFilledUp?: boolean;
	messageId?: number;
	colorMode?: string;
}

interface ThumbsProps {
	messageKey;
	data;
	size: 'small' | 'normal' | 'large';
	thumbBackground?: string;
	thumbBordercolor?: string;
	thumbColor?: string;
	selected?: string;
	centered?: boolean;
	onClick?: Function;
}
// const tenDescription = {
// 	0: ' ',
// 	1: 'Very bad',
// 	2: 'Bad',
// 	3: 'Okay',
// 	4: 'Average',
// 	5: 'Good',
// 	6: 'Very good',
// 	7: 'Excellent!',
// 	8: 'Superb',
// 	9: 'OutStanding',
// 	10: 'Magnificent',
// };
const tenDescription = {
	0: ' ',
	1: 'Poor',
	2: 'Average',
	3: 'Good',
	4: 'Excellent!',
	5: 'OutStanding',
	6: 'Very good',
	7: 'Excellent',
	8: 'Superb',
	9: 'Outstanding',
	10: 'Magnificent',
};
const reviewTranslator = (data: string) => {
	if (data === 'Very Bad') {
		return <T labelName='VeryBadLabel' langCode='en' />;
	} else if (data === 'Bad') {
		return <T labelName='BadLabel' langCode='en' />;
	} else if (data === 'Okay') {
		return <T labelName='OkayLabel' langCode='en' />;
	} else if (data === 'Good') {
		return <T labelName='GoodLabel' langCode='en' />;
	} else if (data === 'Excellent') {
		return <T labelName='ExcellentLabel' langCode='en' />;
	}
};
const fiveDescription = {
	0: ' ',
	// 1: 'dddd',
	// 1: reviewTranslator('Very Bad'),
	// 2: reviewTranslator('Bad'),
	// 3: reviewTranslator('Okay'),
	// 4: reviewTranslator('Good'),
	// 5: reviewTranslator('Excellent'),
	1: 'Poor',
	2: 'Average',
	3: 'Good',
	4: 'Excellent',
	5: 'Outstanding',
};

const threeDescription = {
	0: ' ',
	1: reviewTranslator('Bad'),
	3: reviewTranslator('Okay'),
	5: reviewTranslator('Good'),
};

const styleVars = getComputedStyle(document.querySelector(':root'));
var r = document.querySelector(':root') as any;

const FFRatingDIV = styled.div`
	.rating-label {
		color: ${(props) => {
			return props.colorMode === 'dark'
				? 'var(--selectedColor)'
				: 'var(--colorScale-2)';
		}} !important;
	}
`;
export const StarRating = (props: Props) => {
	const { number = 5, filled = 0, onChange, description, noLabel } = props;
	const [filledStars, setFilledStars] = React.useState(0);
	const [hoveredStars, setHoveredStars] = React.useState(0);
	const [clickable, setClickable] = React.useState(true);
	const [space, setSpace] = React.useState(false);

	const ratingLabel: any = description
		? description
		: number === 10
		? tenDescription
		: number === 5
		? fiveDescription
		: number === 3
		? threeDescription
		: null;
	React.useEffect(() => {
		setFilledStars(filled);
		setHoveredStars(0);
	}, [filled]);

	React.useEffect(() => {
		if (props.foregroundColor)
			r.style.setProperty(
				'--selectedColor',
				props.foregroundColor || '#ffffff'
			);
	}, [props.foregroundColor]);

	React.useEffect(() => {
		if (props.isClickable === true || props.isClickable === false)
			setClickable(props.isClickable);
	}, [props.isClickable]);
	React.useEffect(() => {
		if (props.purpose) setSpace(true);
	}, [props.purpose]);
	// const foreground =
	// 	styleVars.getPropertyValue('--selectedColor') ||
	// 	props.foregroundColor ||
	// 	'#ffffff';
	const foreground = 'rgba(0,0,0,0.4)';
	const modeGroundColor =
		props.colorMode === 'dark' ? 'var(--selectedColor)' : 'var(--colorScale-2)';
	const rangeArray = [];
	for (let i = 0; i < number; i += 1) {
		rangeArray.push(i);
	}
	return (
		<FFRatingDIV
			colorMode={props.colorMode}
			className={`${
				props.channel === 'whatsapp' ? 'rating-box-whatsapp' : 'rating-box'
			}`}
		>
			<div
				className={`rating-items ${space ? 'rating-space' : ''} `}
				aria-label={
					!clickable &&
					`${filledStars} ${TString({
						labelName: 'starSelectedLabel',
						langCode: 'en',
					})}`
				}
				style={{
					width: props.width ? props.width : '',
					// gap: props.number > 5 ? 0 : '8px',
					gridGap: props.gap ? props.gap + 'px' : props.number > 5 ? 0 : '8px',
					cursor: props.disable ? 'not-allowed' : '',
				}}
			>
				{rangeArray.map((e, i) => {
					return (
						<button
							key={e}
							title={
								clickable &&
								`${i + 1} ${TString({
									labelName: 'starLabel',
									langCode: 'en',
								})}`
							}
							disabled={props.disable}
							className={`${clickable ? 'clickable' : 'not-clickable'}  ${
								props.channel ? 'button-whatsapp' : ''
							}
                ${number && number > 5 && !props.iconSize ? 'small' : ''}`}
							style={
								props.iconSize
									? { width: props.iconSize, height: props.iconSize }
									: {}
							}
							onClick={() => {
								if (!props.disable) {
									if (props.onChange) {
										if (props.name) onChange(props.name, e + 1);
										else onChange(e + 1);
									} else {
										setFilledStars(e + 1);
									}
								}
							}}
							onFocus={() => setHoveredStars(filledStars !== 0 ? 0 : e + 1)}
							onBlur={() => setHoveredStars(0)}
							onMouseOver={() => setHoveredStars(filledStars !== 0 ? 0 : e + 1)}
							onMouseOut={() => setHoveredStars(0)}
						>
							<RatingIcons.Star
								fill={
									(hoveredStars !== 0 && e < hoveredStars) ||
									(hoveredStars === 0 && e < filledStars)
										? modeGroundColor
										: foreground
								}
								variant={
									(hoveredStars !== 0 &&
										e < hoveredStars &&
										props.noOutlineHover) ||
									(hoveredStars === 0 && e < filledStars)
										? 'filled'
										: ''
								}
							/>
						</button>
					);
				})}
			</div>
			{noLabel ? null : (
				<div
					className={`${
						props.channel === 'whatsapp'
							? 'rating-label-whatsapp'
							: 'rating-label'
					} ff-chatbot-caption`}
				>
					{ratingLabel ? (
						ratingLabel[hoveredStars !== 0 ? hoveredStars : filledStars] || ''
					) : hoveredStars !== 0 || filledStars !== 0 ? (
						<div>
							<span style={{ fontWeight: 600, color: 'var(--selectedColor)' }}>
								{hoveredStars !== 0 ? hoveredStars : filledStars}
							</span>
							/{number}
						</div>
					) : (
						' '
					)}
				</div>
			)}
		</FFRatingDIV>
	);
};

export const SmileRating = (props: Props) => {
	const { number = 5, filled = 0, onChange, noLabel } = props;
	const [filledSmiles, setFilledSmiles] = React.useState(0);
	const [hoveredSmiles, setHoveredSmiles] = React.useState(0);
	const [clickable, setClickable] = React.useState(true);

	const ratingLabel: any =
		number === 5
			? fiveDescription
			: number === 3
			? threeDescription
			: fiveDescription;
	React.useEffect(() => {
		setFilledSmiles(filled);
		setHoveredSmiles(0);
	}, [filled]);

	React.useEffect(() => {
		if (props.foregroundColor)
			r.style.setProperty('--srvMsgColor', props.foregroundColor || '#ffffff');
	}, [props.foregroundColor]);
	React.useEffect(() => {
		if (props.isClickable === true || props.isClickable === false)
			setClickable(props.isClickable);
	}, [props.isClickable]);
	var rangeArray = [];
	if (number === 3) {
		rangeArray = [0, 2, 4];
	} else {
		for (let i = 0; i < 5; i += 1) {
			rangeArray.push(i);
		}
	}
	var tooltips1 = {
		0: 'Sad',
		1: 'Neutral',
		2: 'Happy',
	};
	var tooltips = {
		0: 'SuperSad',
		1: 'Sad',
		2: 'Neutral',
		3: 'Happy',
		4: 'SuperHappy',
	};
	// const foreground =
	// 	styleVars.getPropertyValue('--srvMsgColor') ||
	// 	props.foregroundColor ||
	// 	'#ffffff';
	const foreground = 'rgba(0,0,0,0.4)';

	const renderIcon = (e: number) => {
		switch (e) {
			case 0:
				return (
					<RatingIcons.SuperSad
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);

			case 1:
				return number === 3 ? (
					<RatingIcons.Neutral
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				) : (
					<RatingIcons.Sad
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);
			case 2:
				return number === 3 ? (
					<RatingIcons.SuperHappy
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				) : (
					<RatingIcons.Neutral
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);

			case 3:
				return (
					<RatingIcons.Happy
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);

			case 4:
				return (
					<RatingIcons.SuperHappy
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);

			default:
				return (
					<RatingIcons.Neutral
						fill={
							(hoveredSmiles !== 0 && e + 1 === hoveredSmiles) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? foreground
								: foreground + '99'
						}
						variant={
							(hoveredSmiles !== 0 &&
								e + 1 === hoveredSmiles &&
								props.noOutlineHover) ||
							(hoveredSmiles === 0 && e + 1 === filledSmiles)
								? 'filled'
								: ''
						}
					/>
				);
		}
	};

	return (
		<div className='rating-box'>
			<div
				className={`rating-items `}
				aria-label={
					!clickable &&
					`${
						rangeArray.length === 3
							? tooltips1[filledSmiles - 1]
							: tooltips[filledSmiles - 1]
					} ${TString({ labelName: 'SelectedLabel', langCode: 'en' })}`
				}
				style={{
					width: props.width ? props.width : '',
					gap: '4',
					gridGap: props.number > 5 ? 0 : '4px',
					cursor: props.disable ? 'not-allowed' : '',
				}}
			>
				{rangeArray.map((e, i) => {
					return (
						<button
							title={rangeArray.length === 3 ? tooltips1[i] : tooltips[i]}
							disabled={props.disable}
							className={clickable ? 'clickable' : 'not-clickable'}
							style={
								props.iconSize
									? {
											width: props.iconSize,
											height: props.iconSize,
									  }
									: {}
							}
							key={i}
							onClick={() => {
								if (!props.disable) {
									if (props.onChange) {
										if (props.name) onChange(props.name, i + 1);
										else onChange(i + 1);
									} else {
										setFilledSmiles(i + 1);
									}
								}
							}}
							onFocus={() => setHoveredSmiles(filledSmiles !== 0 ? 0 : i + 1)}
							onBlur={() => setHoveredSmiles(0)}
							onMouseOver={() =>
								setHoveredSmiles(filledSmiles !== 0 ? 0 : i + 1)
							}
							onMouseOut={() => setHoveredSmiles(0)}
						>
							{renderIcon(i)}
						</button>
					);
				})}
			</div>
			{noLabel ? null : (
				<div className={'rating-label caption-text'}>
					{ratingLabel[hoveredSmiles !== 0 ? hoveredSmiles : filledSmiles] ||
						' '}
				</div>
			)}
		</div>
	);
};

export const ThumbRating = (props: Props & ThumbsProps) => {
	const [filledThumb, setFilledThumb] = React.useState('');
	const [hoveredThumb, setHoveredThumb] = React.useState('');

	React.useEffect(() => {
		setFilledThumb(props.selected);
	}, [props.selected]);

	React.useEffect(() => {
		if (props.foregroundColor)
			r.style.setProperty('--srvMsgColor', props.foregroundColor || '#ffffff');
	}, [props.foregroundColor]);
	const foreground = 'rgba(0,0,0,0.4)';
	const modeGroundColor =
		props.colorMode === 'dark' ? 'var(--selectedColor)' : 'var(--colorScale-2)';
	const background = styleVars.getPropertyValue('--thumbBackground');
	const border = props.isResponselevelFeedback
		? styleVars.getPropertyValue('--thumbBordercolor')
		: 'transparent';
	let label = 'Thank you for your feedback';

	function selectThumbs(bool, data, msgKey, callbackIndicator?) {
		if ((bool && filledThumb !== 'Up') || (!bool && filledThumb !== 'Down')) {
			let popCommentOnFeedback = data.popComment
				? JSON.parse(data.popComment)
				: false;

			const setFilledThumbsCalculation = () => {
				setFilledThumb(
					((filledThumb === 'Up' && bool) ||
						(filledThumb === 'Down' && !bool)) &&
						!callbackIndicator
						? ''
						: bool
						? 'Up'
						: 'Down'
				);
			};

			if (props.data.isInsideAware) {
				window['internalFeedbackBanner']();
				setFilledThumbsCalculation();
				return;
			}

			if (props.selected) {
				setFilledThumbsCalculation();
				props.onClick(
					((filledThumb === 'Up' && bool) ||
						(filledThumb === 'Down' && !bool)) &&
						!callbackIndicator
						? ''
						: bool
						? 'Up'
						: 'Down'
				);
				return;
			}

			// DataAPI()
			// 	.get(
			// 		'/update?key=' +
			// 		msgKey +
			// 		'&accept=' +
			// 		(bool === null
			// 			? null
			// 			: ((filledThumb === 'Up' && bool) ||
			// 				(filledThumb === 'Down' && !bool)) &&
			// 				!callbackIndicator
			// 				? null
			// 				: bool)
			// 	)
			// 	.then((response) => {
			// 		if (bool === null) {
			// 			setFilledThumb('');
			// 			return;
			// 		}
			// 		setFilledThumbsCalculation();

			// 		if (
			// 			!callbackIndicator &&
			// 			popCommentOnFeedback &&
			// 			(filledThumb === undefined ||
			// 				filledThumb === null ||
			// 				filledThumb === '' ||
			// 				(filledThumb === 'Up' && !bool) ||
			// 				(filledThumb === 'Down' && bool))
			// 		) {
			// 			window['toggleMsgFeed'](
			// 				bool,
			// 				JSON.stringify(msgKey),
			// 				(val, indicator?) => selectThumbs(val, data, msgKey, indicator),
			// 				bool ? 'Up' : 'Down' //filledThumb
			// 			);
			// 		} else {
			// 			if (bool === null) {
			// 				return;
			// 			}

			// 			window['popUpSnackBar'](label);
			// 		}
			// 	})
			// 	.catch((error) => {
			// 		console.log(error);
			// 	});
			setFilledThumbsCalculation();
		} else {
			if (props.isResponselevelFeedback) {
				setFilledThumb('');
			}
		}
	}

	return (
		<div
			className={`sf-thumbs-wrapper ${props.size}`}
			style={{
				margin: props.centered ? '0 auto' : '',
				backgroundColor: background,
				border: `1px solid ${border}`,
			}}
		>
			<button
				title={TString({ labelName: 'thumbsUpLabel', langCode: 'en' })}
				className='sf-thumbs sf-thumbs-up clickable'
				disabled={props.voiceResponse}
				onClick={(ev) => {
					selectThumbs(true, props.data, props.messageKey);

					props.openThumbsPopup(true, true, props.messageId);
				}}
				onFocus={() => {
					setHoveredThumb('Up');
				}}
				onMouseOver={() => {
					setHoveredThumb('Up');
				}}
				onMouseOut={() => setHoveredThumb('')}
			>
				<RatingIcons.ThumbsUp
					fill={
						// foreground
						hoveredThumb === 'Up' || props.thumbFilledUp === true
							? modeGroundColor
							: foreground
					}
					variant={
						(hoveredThumb === 'Up' && props.noOutlineHover) ||
						props.thumbFilledUp === true
							? 'filled'
							: ''
						// props.thumbFilledUp === true ? 'filled' : ''
					}
				/>
			</button>
			<button
				title={TString({ labelName: 'thumbsDownLabel', langCode: 'en' })}
				className='sf-thumbs sf-thumbs-down clickable'
				disabled={props.voiceResponse}
				onClick={(ev) => {
					selectThumbs(false, props.data, props.messageKey);
					props.openThumbsPopup(true, false, props.messageId);
				}}
				onFocus={() => {
					setHoveredThumb('Down');
				}}
				onMouseOver={() => {
					setHoveredThumb('Down');
				}}
				onMouseOut={() => setHoveredThumb('')}
			>
				<RatingIcons.ThumbsDown
					fill={
						// foreground
						hoveredThumb === 'Down' || props.thumbFilledUp === false
							? modeGroundColor
							: foreground
					}
					variant={
						(hoveredThumb === 'Down' && props.noOutlineHover) ||
						props.thumbFilledUp === false
							? 'filled'
							: ''
						// props.thumbFilledUp === false ? 'filled' : ''
					}
				/>
			</button>
		</div>
	);
};
